<template>
  <v-dialog
    :value="enableDialog"
    width="600"
    persistent
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="salesItemUnitFormValidation"
    >
      <v-form>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>{{ targetId ? '売上品目単位編集' : '売上品目単位追加' }}</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:10"
                  class="requiredMark"
                  name="コード"
                >
                  <v-text-field
                    v-model="forms.code"
                    :error-messages="errors"
                    :disabled="!forms.can_remove"
                    dense
                    label="コード"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）UN003"
                    required
                  >
                    <template v-slot:label>
                      <span>コード</span>
                      <span class="ml-1">
                        ({{ forms.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:4"
                  class="requiredMark"
                  name="単位名"
                >
                  <v-text-field
                    v-model="forms.name"
                    :error-messages="errors"
                    :disabled="!forms.can_remove"
                    dense
                    label="単位名"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）kg"
                    required
                  >
                    <template v-slot:label>
                      <span>単位名</span>
                      <span class="ml-1">
                        ({{ forms.name?.length || 0 }} / 4)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="表示順"
                  rules="numeric|min_value:0|max_value:99999"
                >
                  <v-text-field
                    v-model="forms.sort_priority"
                    :error-messages="errors"
                    :show-size="1000"
                    dense
                    label="表示順"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    reverse
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn @click="closeButtonClickEvent">
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetId: {
      type: Number,
      default: () => null,
    }
  },
  data () {
    return {
      inputtedKeyword: null,
      forms: {
        /** コード */
        code: null,
        /** 単位名 */
        name: null,
        /** 表示順 */
        sort_priority: null,
        can_remove: true,
      },
    }
  },

  computed: {
  },
  watch: {
    enableDialog (value) {
      this.$nextTick(() => this.$refs.salesItemUnitFormValidation.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (value) {
        if (this.targetId) {
          this.searchEditSalesItemUnit()
        }
      }
    }
  },
  created() {
  },
  methods: {
    /** api取得 */
    ...mapActions('DriverMasterSalesItemUnit', {
      editSalesItemUnit: 'edit',
      createSalesItemUnit: 'create',
      updateSalesItemUnit: 'update',
    }),

    /**
     * 編集時表示情報取得
     */
    searchEditSalesItemUnit () {
      this.editSalesItemUnit({ id: this.targetId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
    * 登録ボタン クリックイベント
    */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.salesItemUnitFormValidation.validate().then((result) => {
        if(result){
          $self.SendRegistrationInformation()
        }
      })
    },
    SendRegistrationInformation(){
      if (this.targetId) {
        this.updateSalesItemUnit({ id: this.targetId, params: this.forms}).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        this.createSalesItemUnit({ params: this.forms }).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
  }
}
</script>
